export default __webpack_public_path__ + "static/informative-400-1646ffb0424764f8ac432924431c3418.webp";